(function () {
  'use strict';

  var portal = document.querySelector('[data-dropshipping-portal]');
  if (!portal) return;

  document.body.classList.add('odp-page-active');
  portal.classList.add('is-enhanced');

  var modelData = {
    standard: {
      label: 'Standard dropshipping',
      title: 'Start with ready-to-ship and factory-direct products.',
      copy: 'Place approved customer orders through the storefront or the assigned account workflow. Oahlan confirms availability, packing requirements, shipping method, and tracking.',
      inventory: 'No reserved stock required for eligible styles',
      branding: 'Neutral packing configuration by agreement',
      best: 'Product validation and lean retail operations'
    },
    branded: {
      label: 'Brand-ready dropshipping',
      title: 'Build a recognizable customer experience without operating your own packing line.',
      copy: 'Coordinate approved packaging, inserts, engraving, labeling, or product adjustments before fulfillment begins. Artwork, samples, minimums, and timing are confirmed by quote.',
      inventory: 'Defined by the approved packaging or product brief',
      branding: 'Logo, insert, box, pouch, or engraving by agreement',
      best: 'Growing brands that need a distinct presentation'
    },
    warehouse: {
      label: 'Virtual warehouse',
      title: 'Reserve proven inventory for a more predictable repeat-order workflow.',
      copy: 'Purchase agreed stock and keep it allocated within Oahlan\'s fulfillment workflow. Dispatch rules, replenishment points, aging stock, and exception handling are agreed during setup.',
      inventory: 'Purchased inventory reserved for the approved account',
      branding: 'Defined within the reserved-stock specification',
      best: 'Repeat sellers prioritizing continuity and planning'
    }
  };

  var modelButtons = portal.querySelectorAll('[data-model]');
  var modelPanel = portal.querySelector('[data-model-panel]');

  function setText(selector, value) {
    var element = modelPanel && modelPanel.querySelector(selector);
    if (element) element.textContent = value;
  }

  function selectModel(key) {
    var data = modelData[key];
    if (!data || !modelPanel) return;

    modelButtons.forEach(function (button) {
      var active = button.getAttribute('data-model') === key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    setText('[data-model-label]', data.label);
    setText('[data-model-title]', data.title);
    setText('[data-model-copy]', data.copy);
    setText('[data-model-inventory]', data.inventory);
    setText('[data-model-branding]', data.branding);
    setText('[data-model-best]', data.best);
  }

  modelButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      selectModel(button.getAttribute('data-model'));
    });
  });

  var revealItems = portal.querySelectorAll('[data-odp-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  var successMessage = portal.querySelector('[data-form-success]');
  if (successMessage) {
    successMessage.focus();
    successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  portal.addEventListener('click', function (event) {
    var actionElement = event.target.closest('[data-portal-action]');
    if (!actionElement) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'dropshipping_portal_action',
      portal_action: actionElement.getAttribute('data-portal-action'),
      portal_state: portal.getAttribute('data-portal-state') || 'unknown'
    });
  });
})();
